module.exports = __webpack_public_path__ + "static/guide.31c81735.png";